"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decode = exports.encode = exports.toGeneral = exports.code = exports.name = void 0;

var signing_1 = __importDefault(require("./signing"));

var encryption_1 = __importDefault(require("./encryption"));

var cbor = __importStar(require("@ipld/dag-cbor"));

exports.name = 'dag-jose';
exports.code = 133;

function isDagJWS(jose) {
  return 'payload' in jose && typeof jose.payload === 'string' && 'signatures' in jose && Array.isArray(jose.signatures);
}

function isEncodedJWS(jose) {
  return 'payload' in jose && jose.payload instanceof Uint8Array && 'signatures' in jose && Array.isArray(jose.signatures);
}

function isEncodedJWE(jose) {
  return 'ciphertext' in jose && jose.ciphertext instanceof Uint8Array && 'iv' in jose && jose.iv instanceof Uint8Array && 'protected' in jose && jose.protected instanceof Uint8Array && 'tag' in jose && jose.tag instanceof Uint8Array;
}

function isDagJWE(jose) {
  return 'ciphertext' in jose && typeof jose.ciphertext === 'string' && 'iv' in jose && typeof jose.iv === 'string' && 'protected' in jose && typeof jose.protected === 'string' && 'tag' in jose && typeof jose.tag === 'string';
}

function toGeneral(jose) {
  if (typeof jose === 'string') {
    var split = jose.split('.');

    if (split.length === 3) {
      return signing_1.default.fromSplit(split);
    } else if (split.length === 5) {
      return encryption_1.default.fromSplit(split);
    }

    throw new Error('Not a valid JOSE string');
  }

  if (isDagJWS(jose) || isDagJWE(jose)) {
    return jose;
  }

  throw new Error('Not a valid unencoded JOSE object');
}

exports.toGeneral = toGeneral;

function encode(obj) {
  if (typeof obj === 'string') {
    obj = toGeneral(obj);
  }

  var encodedJose;

  if (isDagJWS(obj)) {
    encodedJose = signing_1.default.encode(obj);
  } else if (isDagJWE(obj)) {
    encodedJose = encryption_1.default.encode(obj);
  } else {
    throw new Error('Not a valid JOSE object');
  }

  return new Uint8Array(cbor.encode(encodedJose));
}

exports.encode = encode;

function decode(data) {
  var encoded;

  try {
    encoded = cbor.decode(data);
  } catch (e) {
    throw new Error('Not a valid DAG-JOSE object');
  }

  if (isEncodedJWS(encoded)) {
    return signing_1.default.decode(encoded);
  } else if (isEncodedJWE(encoded)) {
    return encryption_1.default.decode(encoded);
  } else {
    throw new Error('Not a valid DAG-JOSE object');
  }
}

exports.decode = decode;